import Vuelidate from "vuelidate";

const init = (vue) => {
  vue.use(Vuelidate);
};

export default init;
